var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.opened
    ? _c("section", [
        _c(
          "div",
          {
            staticClass: "dropdown",
            class: { "top-round-box": _vm.topRoundBox, half: !_vm.halfClose }
          },
          [
            _c("div", { staticClass: "dropdown-content" }, [
              _c(
                "div",
                {
                  staticClass: "dropdown-content-header",
                  on: {
                    click: function() {
                      _vm.halfClose = _vm.topRoundBox
                        ? !_vm.halfClose
                        : _vm.halfClose
                    }
                  }
                },
                [
                  _c("div", { staticClass: "close" }, [
                    _vm.topRoundBox
                      ? _c("div", { staticClass: "bar" })
                      : _c("i", {
                          staticClass: "icon icon-dropdown",
                          on: {
                            click: function($event) {
                              return _vm.close()
                            }
                          }
                        })
                  ])
                ]
              ),
              _vm.dropdownBody
                ? _c(
                    "div",
                    { staticClass: "dropdown-body" },
                    [_vm._t("content")],
                    2
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }